import React from 'react';
import BaseAbstract from './BaseAbstract';

export default class Image extends BaseAbstract {
    
    renderValue() {

        return <img className={ this.props.className } alt={ this.state.value.text }  src={ this.state.value.link } />;
    }
}